import { AllCommunityModule, ModuleRegistry, themeQuartz, type ColDef } from 'ag-grid-community'

// Registered once, for the whole app. AG Grid v33 onwards ships nothing until a module
// is registered, and the failure is a runtime error rather than a blank grid.
ModuleRegistry.registerModules([AllCommunityModule])

/**
 * The grid's own theme, pulled toward the Admin Site's tokens.
 *
 * AG Grid v33 onwards themes in JavaScript rather than by importing a stylesheet, which
 * is what lets it sit beside Tailwind instead of fighting it: nothing global is injected
 * and none of its classes leak out of the grid. Only the parameters that would otherwise
 * clash are overridden -- the font, the accent, the surfaces -- and the rest of Quartz is
 * left alone, because the point of taking a real grid was not to rebuild one.
 *
 * Shared, and not copied per screen. Two grids with their own copy of these values are two
 * grids that drift, and the second one always looks nearly right rather than wrong, which
 * is the hard kind to notice.
 */
export const gridTheme = themeQuartz.withParams({
  fontFamily: 'inherit',
  headerFontWeight: 700,
  accentColor: '#1b5e20',
  backgroundColor: '#ffffff',
  borderColor: '#e6e1d6',
  headerBackgroundColor: '#faf7f0',
  oddRowBackgroundColor: '#fcfaf5',
  rowHoverColor: '#f0f5ef',
  selectedRowBackgroundColor: '#e8f0e6',
  wrapperBorderRadius: 8,
})

/**
 * What every column does unless it says otherwise: the filter row under the heading, and
 * a column you can sort and drag wider.
 */
export const defaultColDef = {
  filter: true,
  floatingFilter: true,
  sortable: true,
  resizable: true,
  suppressHeaderMenuButton: false,
  // `satisfies` rather than an annotation: none of these keys depend on the row type, so
  // this spreads into a ColDef<Question> and a ColDef<TopicRow> alike. Annotating it
  // ColDef would widen `field` to string and break both.
} satisfies ColDef
